import { DeliveryTypeCategory as AppDeliveryTypeCategory } from '@/features/orders/constants/app'
import { DeliveryTypeCategory as FirebaseDeliveryTypeCategory } from '@/features/orders/constants/firebase'

export const firebaseToAppDeliveryTypeCategory: Record<
    FirebaseDeliveryTypeCategory,
    AppDeliveryTypeCategory
> = {
    [FirebaseDeliveryTypeCategory.Delivery]: AppDeliveryTypeCategory.Delivery,
    [FirebaseDeliveryTypeCategory.Takeaway]: AppDeliveryTypeCategory.Takeaway,
    [FirebaseDeliveryTypeCategory.EatIn]: AppDeliveryTypeCategory.EatIn,
}
